export default __webpack_public_path__ + "static/media/noom-analysis.11176394.png";